<template>
    <aside class="admin-sidebar" :class="{
        'sidebar-collapsed': sidebarCollapse && !sidebarExpandHover,
        'sidebar-collapsing': sidebarCollapsing,
    }">
        <div v-on:mousedown="onMobileOverlayClick" class="sidebar-mobile-overlay"></div>
        <div>
            <!--v-on:mouseenter="onSidebarHover" v-on:mouseleave="onSidebarOut"-->
            <router-link :to="{ path: '/app' }" class="brand-link brand-link-colors">
                <img class="site-top-logo" src="../../assets/images/rms-logo.png" alt="RMS Logo"
                    v-if="generalOptions.app_id == 1" />
                <img class="site-top-logo" src="../../assets/images/rmb-logo.png" alt="RMB Logo"
                    v-if="generalOptions.app_id == 2" />
                <img class="site-top-logo" src="../../assets/images/rmg-logo.png" alt="RMG logo"
                    v-if="generalOptions.app_id == 3" />
                <img class="site-top-logo" src="../../assets/images/rml-logo.png" alt="RML Logo"
                    v-if="generalOptions.app_id == 5" />
            </router-link>
            <perfect-scrollbar class="sidebar-inner">
                <div class="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div class="image">
                        <div class="header-member-avatar" v-if="user && user.avatar">
                            <img v-bind:src="user.avatar" />
                        </div>
                        <div class="
                                header-member-avatar
                                sidebar-initials
                                d-flex
                                justify-content-center
                                align-items-center
                            " v-if="user && !user.avatar">
                            <div>{{ getInitial(user.first_name) }}</div>
                            <div v-if="user.last_name">{{ getInitial(user.last_name) }}</div>
                        </div>
                    </div>
                    <div v-if="user" class="info">
                        <router-link :to="{ path: '/app' }" class="d-block">{{ user.first_name }} {{ user.last_name
                        }}</router-link>
                        <div v-if="localNotificationCount" class="user-unread-messages">
                            <router-link :to="{ path: '/app/contact-us' }">
                                {{ localNotificationCount }}
                                <span>unread <span v-if="localNotificationCount === 1">message</span><span
                                        v-if="localNotificationCount > 1">messages</span>
                                </span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <nav class="mt-2">
                    <ul class="nav nav-pills nav-sidebar flex-column">
                        <!--Dashboard-->
                        <li class="nav-item">
                            <router-link :to="{ path: '/app' }" class="nav-link" v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-calendar"></i>
                                <span v-if="user && user.role == 'client'">{{
                                    $t("adminMenu.appointments")
                                }}</span>
                                <span v-else>{{ $t("adminMenu.dashboard") }}</span>
                            </router-link>
                        </li>
                        <!--Profile-->
                        <li class="nav-item">
                            <router-link :to="{ path: '/app/profile' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-user"></i>
                                <span>{{ $t("adminMenu.profile") }}</span>
                            </router-link>
                        </li>
                        <!--Services-->
                        <li class="nav-item" v-if="isStylist" :class="{ 'menu-open': submenusExpanded.services }">
                            <a v-on:click="submenusExpanded.services = !submenusExpanded.services"
                                :class="{ 'router-link-active': submenusExpanded.services }" href="javascript:void(0)"
                                class="nav-link has-subnav">
                                <i class="nav-icon fa fa fa-handshake-o"></i>
                                <span>{{ $t("adminMenu.servicesAndProducts") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/services' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.services") }}</span>
                                    </router-link>
                                </li>
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/products' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.products") }}</span>
                                    </router-link>
                                </li>

                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/services/categories' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.categories") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <!--Favorites-->
                        <li class="nav-item" v-if="!isStylist">
                            <router-link :to="{ path: '/app/stylists' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-users"></i>
                                <span>{{ $t("adminMenu.favorites") }}</span>
                            </router-link>
                        </li>
                        <!--Clients-->
                        <li class="nav-item" v-if="isStylist">
                            <router-link :to="{ path: '/app/clients' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-users"></i>
                                <span>{{ $t("adminMenu.myClients") }}</span>
                            </router-link>
                        </li>
                        <!--Marketing-->
                        <li class="nav-item" v-if="isStylist" :class="{ 'menu-open': submenusExpanded.marketing }">
                            <a v-on:click="submenusExpanded.marketing = !submenusExpanded.marketing"
                                :class="{ 'router-link-active': submenusExpanded.marketing }" href="javascript:void(0)"
                                class="nav-link has-subnav">
                                <i class="nav-icon fa fa-line-chart"></i>
                                <span>{{ $t("adminMenu.marketing") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <!--Special Offers-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/marketing/special-offers' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.specialOffers") }}</span>
                                    </router-link>
                                </li>
                                <!--Push Notifications-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/marketing/message-all-clients' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.pushNotifications") }}</span>
                                    </router-link>
                                </li>
                                <!--Text Messages-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/marketing/text-messages' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.smsNotifications") }}</span>
                                    </router-link>
                                </li>
                                <!--Text Messages-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/marketing/email' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.emailNotifications") }}</span>
                                    </router-link>
                                </li>
                                <!--Portfolio Images-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/portfolio-pictures' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.portfolioPictures") }}</span>
                                    </router-link>
                                </li>
                                <!--Portfolio Videos-->
                                <li v-if="user && user.id === 35321" class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/portfolio-videos' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.portfolioVideos") }}</span>
                                    </router-link>
                                </li>
                                <!--Social Links-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/marketing/social-links' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.socialLinks") }}</span>
                                    </router-link>
                                </li>
                                <!--Referral-->
                                <li v-if="user && user.role == 'stylist'" class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/referral' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.referral") }}</span>
                                    </router-link>
                                </li>
                                <!--Booking Widget-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/marketing/booking-widget' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.bookingWidget") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <!--Waiting List-->
                        <li class="nav-item" v-if="isStylist && hasWaitlistAccess"
                            :class="{ 'menu-open': submenusExpanded.waitingList }">
                            <a v-on:click="submenusExpanded.waitingList = !submenusExpanded.waitingList"
                                :class="{ 'router-link-active': submenusExpanded.waitingList }"
                                href="javascript:void(0)" class="nav-link has-subnav">
                                <i class="nav-icon fa fa-clock-o" aria-hidden="true"></i>
                                <span>{{ $t("adminMenu.waitingList") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <!-- Enrollment-->
                                <li class="nav-item sub-menu-item"
                                    v-if="!adminDetails.waiting_list_subscription_active || !adminDetails.waiting_list_enrollment_finished && adminDetails.waiting_list_subscription_active">
                                    <router-link :to="{ path: '/app/waiting-list/enrollment' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.enrollment") }}</span>
                                    </router-link>
                                </li>
                                <li class="nav-item sub-menu-item"
                                    v-if="adminDetails.waiting_list_active && !adminDetails.web_trial_expired">
                                    <router-link :to="{ path: '/app/waiting-list/dashboard' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.waitingListDashboard") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <!--Client Waiting List-->
                        <li class="nav-item" v-if="!isStylist && hasStylistsWithWaitlist">
                            <router-link :to="{ path: '/app/waiting-list' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-clock-o" aria-hidden="true"></i>
                                <span>{{ $t("adminMenu.waitingList") }}</span>
                            </router-link>
                        </li>
                        <!--Payments and Deposits-->
                        <li class="nav-item" v-if="isStylist"
                            :class="{ 'menu-open': submenusExpanded.paymentsDeposits }">
                            <a v-on:click="submenusExpanded.paymentsDeposits = !submenusExpanded.paymentsDeposits"
                                :class="{
                                    'router-link-active': submenusExpanded.paymentsDeposits,
                                }" href="javascript:void(0)" class="nav-link has-subnav">
                                <i class="nav-icon fa fa-credit-card"></i>
                                <span>{{ $t("adminMenu.paymentsDeposits") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <!-- PaymentSettings -->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/payments/settings' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.paymentSettings") }}</span>
                                    </router-link>
                                </li>
                                <!-- Complete Checkout -->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/payments/complete-checkout' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>
                                            {{ $t("adminMenu.completeCheckout") }}({{ checkoutAppointentsCount
                                            }})
                                        </span>
                                    </router-link>
                                </li>
                                <!-- Refunds -->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/payments/refunds' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.refunds") }}</span>
                                    </router-link>
                                </li>
                                <!-- Statements -->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/payments/statements' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.transactions") }}</span>
                                    </router-link>
                                </li>
                                <!-- Per-Client-Restrictions -->
                                <li class="nav-item sub-menu-item" v-if="hasPolicyEnabled">
                                    <router-link :to="{ path: '/app/per-client-restrictions' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.perClientRestrictions") }}</span>
                                    </router-link>
                                </li>
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/billing-purchases' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.billingPurchases") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <!--Fees and policies-->
                        <li class="nav-item" v-if="isStylist">
                            <router-link :to="{ path: '/app/policy/fees-and-policies' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-book" aria-hidden="true"></i>
                                <span>{{ $t("adminMenu.feesAndPolicies") }}</span>
                            </router-link>
                        </li>
                        <!--Team-->
                        <!-- <li class="nav-item" v-if="isStylist && showTeam">
                            <router-link
                                :to="{ path: '/app/team' }"
                                class="nav-link"
                                v-on:click.native="closeMobileMenu"
                            >
                                <i class="nav-icon fa fa-users"></i>
                                <span>{{ $t("adminMenu.team") }}</span>
                            </router-link>
                        </li> -->
                        <li class="nav-item" v-if="isStylist && showTeam"
                            :class="{ 'menu-open': submenusExpanded.team }">
                            <a v-on:click="submenusExpanded.team = !submenusExpanded.team"
                                :class="{ 'router-link-active': submenusExpanded.team }" href="javascript:void(0)"
                                class="nav-link has-subnav">
                                <i class="nav-icon fa fa-users"></i>
                                <span>{{ $t("adminMenu.team") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <!-- Salon Details -->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/salon-details' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.salonDetails") }}</span>
                                    </router-link>
                                </li>
                                <!-- Salon Team Members -->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/salon-team-members' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.salonTeamMembers") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <!--Team Member-->
                        <li class="nav-item" v-if="isStylist && showTeamMember">
                            <router-link :to="{ path: '/app/team-member' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-users"></i>
                                <span>{{ $t("adminMenu.team") }}</span>
                            </router-link>
                        </li>
                        <!--Payments-->
                        <li class="nav-item" v-if="!isStylist" :class="{ 'menu-open': submenusExpanded.payments }">
                            <a v-on:click="submenusExpanded.payments = !submenusExpanded.payments"
                                :class="{ 'router-link-active': submenusExpanded.payments }" href="javascript:void(0)"
                                class="nav-link has-subnav">
                                <i class="nav-icon fa fa-credit-card"></i>
                                <span>{{ $t("adminMenu.payments") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <!--Credit Cards-->
                            <ul class="nav nav-treeview">
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/payments/credit-cards' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.creditCards") }} ({{ totalCards }})</span>
                                    </router-link>
                                </li>
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/payments/transactions' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.transactions") }} ({{ clientPaymentsTotal }})</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <!--Work Settings-->
                        <li class="nav-item" v-if="isStylist" :class="{ 'menu-open': submenusExpanded.workSettings }">
                            <a v-on:click="submenusExpanded.workSettings = !submenusExpanded.workSettings"
                                :class="{ 'router-link-active': submenusExpanded.workSettings }"
                                href="javascript:void(0)" class="nav-link has-subnav">
                                <i class="nav-icon fa fa-calendar-check-o"></i>
                                <span>{{ $t("adminMenu.workSettings") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/work-settings' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.general") }}</span>
                                    </router-link>
                                </li>
                                <!--Service Hours-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/work-settings/service-hours' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.serviceHours") }}</span>
                                    </router-link>
                                </li>
                                <!--Block Out / Unblock-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/work-settings/blockout-unblock' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.blockoutUnblock") }}</span>
                                    </router-link>
                                </li>
                                <!--Business License-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/work-settings/business-license' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.businessLicense") }}</span>
                                    </router-link>
                                </li>
                                <!--Optimize Scheduling-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/work-settings/optimize-scheduling' }"
                                        class="nav-link" v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.optimizeScheduling") }}</span>
                                    </router-link>
                                </li>
                                <!--Notifications-->
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/work-settings/notifications' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.notifications") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                        <!--Reports-->
                        <!-- <li class="nav-item" v-if="isStylist" :class="{ 'menu-open': submenusExpanded.reports }">
                            <a v-on:click="submenusExpanded.reports = !submenusExpanded.reports"
                                :class="{ 'router-link-active': submenusExpanded.reports }" href="javascript:void(0)"
                                class="nav-link has-subnav">
                                <i class="nav-icon fa fa-bar-chart"></i>
                                <span>{{ $t("adminMenu.reports") }}</span>
                                <i class="pull-right fa fa-angle-left nav-icon-arrow"></i>
                            </a>
                            <ul class="nav nav-treeview">
                              
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/reports/appts' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.apptsReports") }}</span>
                                    </router-link>
                                </li>
                                
                                <li class="nav-item sub-menu-item">
                                    <router-link :to="{ path: '/app/reports/billing-purchases' }" class="nav-link"
                                        v-on:click.native="closeMobileMenu">
                                        <i class="fa fa-circle-o nav-icon"></i>
                                        <span>{{ $t("adminMenu.billingPurchases") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li> -->
                        <!--Scubscription Payments-->
                        <li v-if="user && user.role == 'stylist'" class="nav-item">
                            <router-link :to="{ path: '/app/subscription-payments' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-credit-card-alt" aria-hidden="true"></i>
                                <span>{{ $t("adminMenu.subscriptionSettings") }}</span>
                            </router-link>
                        </li>
                        <!--Client Notifications Settings-->
                        <li class="nav-item" v-if="!isStylist">
                            <router-link :to="{ path: '/app/client-appointments-notifications' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-bell" aria-hidden="true"></i>
                                <span> {{ $t("adminMenu.clientNotificationsSettings") }}</span>
                            </router-link>
                        </li>
                        <!--Contact Us-->
                        <li class="nav-item">
                            <router-link :to="{ path: '/app/contact-us' }" class="nav-link"
                                v-on:click.native="closeMobileMenu">
                                <i class="nav-icon fa fa-envelope" aria-hidden="true"></i>
                                <span>{{ $t("adminMenu.contactUs") }}</span>
                            </router-link>
                        </li>
                        <!--Log Out-->
                        <li class="nav-item">
                            <hr />
                        </li>
                        <li class="nav-item log-out-padding">
                            <a href="#" class="nav-link" v-on:click="logOut">
                                <i class="nav-icon fa fa-sign-out" aria-hidden="true"></i>
                                <span>{{ $t("adminMenu.logout") }}</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </perfect-scrollbar>
        </div>
    </aside>
</template>

<script>
import auth from "./../../services/auth.js";
import store from "./../../services/vuex.js";
import eventBus from "../../services/eventBus.js";
import api from "../../services/apiEndpoints.js";
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';


export default {
    name: "AdminHeader",
    data: function () {
        return {
            user: null,
            isStylist: false,
            showTeam: false,
            showTeamMember: false,
            accountNavExpanded: true,
            sidebarCollapse: true,
            sidebarExpandHover: false,
            sidebarCollapsing: false,
            submenusExpanded: {
                services: false,
                marketing: false,
                workSettings: false,
                payments: false,
                reports: false,
                paymentsDeposits: false,
                feesAndPolicies: false,
                team: false,
                waitingList: false,

            },
            waitlistStylistAccounts: [8, 73], //Temporary limit to the test stylist accounts
            hasWaitlistAccess: false,
            hasStylistsWithWaitlist: false,
        };
    },
    mounted: function () {
        this.user = auth.state.user;

        if (auth.state.user.role == "stylist") {
            this.isStylist = true;

            if (this.waitlistStylistAccounts.indexOf(this.user.id) != -1) {
                this.hasWaitlistAccess = true;
            }
        }

        eventBus.on("admin_details_loaded", () => {
            if (!this.adminDetails.group_active || (this.adminDetails.group_owner && this.adminDetails.group_active)) {
                this.showTeam = true;
            }

            if (
                this.adminDetails.group_active == 1 &&
                this.adminDetails.active == 1 &&
                !this.adminDetails.group_owner
            ) {
                this.showTeamMember = true;
            }

            if (this.user.role == "client") {
                this.getClientPaymentsTotal();
                this.getStylists();
            } else {
                this.getStylistPolicy();
            }

            if (typeof this.adminDetails['has_stylists_with_waiting_list'] != 'undefined') {
                this.hasStylistsWithWaitlist = this.adminDetails['has_stylists_with_waiting_list'];
            }
        });

        eventBus.on("admin_sidebar_collapse", (collapse) => {
            this.sidebarCollapse = collapse;
            this.sidebarCollapsing = true;

            setTimeout(() => {
                this.sidebarCollapsing = false;
            }, 300);
        });

        this.getWaitingListSubscriptionAndSettings();
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        paymentStylists: {
            get: function () {
                return this.$store.state.paymentStylists;
            },
            set: function (value) {
                this.$store.commit("setPaymentStylists", value);
            },
        },
        loadingPaymentStylists: {
            get: function () {
                return this.$store.state.loadingPaymentStylists;
            },
            set: function (value) {
                this.$store.commit("setLoadingPaymentStylists", value);
            },
        },
        squareCards: {
            get: function () {
                return this.$store.state.squareCards;
            },
            set: function (value) {
                this.$store.commit("setSquareCards", value);
            },
        },
        stripeCards: {
            get: function () {
                return this.$store.state.stripeCards;
            },
            set: function (value) {
                this.$store.commit("setStripeCards", value);
            },
        },
        totalCards: {
            get: function () {
                return this.$store.state.totalCards;
            },
            set: function (value) {
                this.$store.commit("setTotalCards", value);
            },
        },
        clientPaymentsTotal: {
            get: function () {
                return this.$store.state.clientPaymentsTotal;
            },
            set: function (value) {
                this.$store.commit("setClientPaymentsTotal", value);
            },
        },
        stylistPolicy: {
            get: function () {
                return this.$store.state.stylistPolicy;
            },
            set: function (value) {
                this.$store.commit("setStylistPolicy", value);
            },
        },
        localNotificationCount: {
            get: function () {
                return this.$store.state.localNotificationCount;
            },
            set: function (value) {
                this.$store.commit("setLocalNotificationCount", value);
            },
        },
        checkoutAppointentsCount: {
            get: function () {
                return this.$store.state.checkoutAppointentsCount;
            },
            set: function (value) {
                this.$store.commit("setCheckoutAppointentsCount", value);
            },
        },
        hasPolicyEnabled: {
            get: function () {
                return this.$store.state.hasPolicyEnabled;
            },
            set: function (value) {
                this.$store.commit("setHasPolicyEnabled", value);
            },
        },
    },
    methods: {
        logOut: function () {
            eventBus.emit("admin_sidebar_collapse", true);
            auth.logout(true);
            this.$router.push("/");
        },
        getInitial: function (name) {
            if (!name) {
                return;
            }
            return name[0].toUpperCase();
        },
        isActiveRoute(routePath) {
            return this.$router.currentRoute.path.indexOf(routePath) != -1;
        },
        onSidebarHover: function () {
            if (!this.sidebarCollapse || window.innerWidth <= 991) {
                return;
            }

            this.sidebarExpandHover = true;
            this.sidebarCollapsing = true;

            setTimeout(() => {
                this.sidebarCollapsing = false;
            }, 300);
        },
        onSidebarOut: function () {
            this.sidebarExpandHover = false;
        },
        onMobileOverlayClick: function () {
            this.sidebarCollapse = true;
            eventBus.emit("admin_sidebar_collapse", this.sidebarCollapse);
        },
        getClientPaymentsTotal: function () {
            this.$http.post(api.actions.get_payments_client, { limit: 100 }).then(
                function (response) {
                    this.paymentsLoaded = true;
                    if (response.data.error) {
                        return;
                    }
                    if (
                        typeof response != "undefined" &&
                        typeof response.data != "undefined" &&
                        typeof response.data.orders != "undefined" &&
                        response.data.orders.length > 0
                    ) {
                        this.clientPaymentsTotal = response.data.orders.length;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        getStylists: function () {
            if (this.loadingPaymentStylists) {
                return;
            }

            this.paymentStylists = [];
            this.loadingPaymentStylists = true;
            this.totalCards = 0;
            this.$http.get(api.actions.get_stylists).then(
                function (response) {
                    this.stylistsLoaded = true;
                    if (response.data.error) {
                        return;
                    }
                    if (
                        typeof response != "undefined" &&
                        typeof response.data != "undefined" &&
                        typeof response.data.stylists != "undefined"
                    ) {
                        this.loadingPaymentStylists = false;
                        response.data.stylists.forEach((stylist) => {
                            if (stylist.stripe_authorized || stylist.square_authorized) {
                                this.paymentStylists.push(stylist);
                                this.getUserCards(stylist);
                            }
                        });
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        getUserCards(stylist) {
            var data = {};

            if (stylist.stripe_authorized) {
                this.$http
                    .get(
                        api.actions.get_stripe_payment_methods +
                        "?user_id=" +
                        this.user.id +
                        "&stylist_id=" +
                        stylist.id
                    )
                    .then((response) => {
                        this.addingCard = false;
                        this.cardsLoaded = false;

                        setTimeout(() => {
                            this.cardsLoaded = true;
                        }, 100);

                        if (response.data.error) {
                            return;
                        }

                        this.stripeCards[stylist.id] = response.data.payment_methods;
                        this.getCardsTotal();
                    });
            } else if (stylist.square_authorized) {
                data = {
                    stylist_id: stylist.id,
                    client_id: this.user.id,
                };

                this.$http.post(api.actions.get_square_customer_cards, data).then((response) => {
                    this.addingCard = false;
                    this.cardsLoaded = false;

                    setTimeout(() => {
                        this.cardsLoaded = true;
                    }, 100);

                    if (response.data.error) {
                        return;
                    }

                    this.squareCards[stylist.id] = response.data.response;
                    this.getCardsTotal();
                });
            }
        },
        getCardsTotal() {
            this.totalCards = 0;

            if (this.squareCards) {
                for (let i in this.squareCards) {
                    this.totalCards += this.squareCards[i].length;
                }
            }

            if (this.stripeCards) {
                for (let i in this.stripeCards) {
                    this.totalCards += this.stripeCards[i].length;
                }
            }
        },
        getStylistPolicy: function () {
            this.loaded = false;
            this.$http.get(api.actions.get_stylist_policy).then(
                function (response) {
                    this.loaded = true;
                    if (response.data.error) {
                        return;
                    }
                    if (
                        typeof response != "undefined" &&
                        typeof response.data != "undefined" &&
                        typeof response.data.policy != "undefined"
                    ) {
                        this.stylistPolicy = response.data.policy;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        getTime() {
            return Math.floor((new Date()).getTime() / 1000);
        },
        closeMobileMenu() {
            // if (window.innerWidth > 991) {
            //     this.onSidebarOut();
            //     return;
            // }

            this.onMobileOverlayClick();
        },
        getWaitingListSubscriptionAndSettings() {
            this.$http.get(api.actions.get_waiting_list_subscription_and_settings).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.waitingListSettings = response.data.waitlist_subscription_and_settings;
            });
            return;
        },
    },
    components: {
        PerfectScrollbar,
    },
};
</script>
